import type { AmbleContent } from "..";
import { ambles as affinityriskagentAmbles } from "./affinityriskagent";
import { ambles as agentdemoAmbles } from "./agentdemo";
import { ambles as agenteroAmbles } from "./agentero";
import { ambles as amsuisseAmbles } from "./amsuisse";
import { ambles as amsuisseChambersbayAmbles } from "./amsuisse-chambersbay";
import { ambles as amsuisseGgiausaAmbles } from "./amsuisse-ggiausa";
import { ambles as appulateAmbles } from "./appulate";
import { ambles as appundAmbles } from "./appund";
import { ambles as bunkerprotectAmbles } from "./bunkerprotect";
import { ambles as firstconnectAmbles } from "./firstconnect";
import { ambles as londonuwAmbles } from "./londonuw";
import { ambles as newageinsAmbles } from "./newageins";
import { ambles as siaaAmbles } from "./siaa";
import { ambles as tarmikaAmbles } from "./tarmika";
import { ambles as tivlyagencyAmbles } from "./tivlyagency";
import { ambles as usginsAmbles } from "./usgins";

/**
 * Site-specific ambles organized by site name
 */
export const siteAmbles: Record<string, Record<string, AmbleContent>> = {
  affinityriskagent: affinityriskagentAmbles,
  agentdemo: agentdemoAmbles,
  agentero: agenteroAmbles,
  amsuisse: amsuisseAmbles,
  "amsuisse-chambersbay": amsuisseChambersbayAmbles,
  "amsuisse-ggiausa": amsuisseGgiausaAmbles,
  appulate: appulateAmbles,
  appund: appundAmbles,
  bunkerprotect: bunkerprotectAmbles,
  firstconnect: firstconnectAmbles,
  londonuw: londonuwAmbles,
  newageins: newageinsAmbles,
  siaa: siaaAmbles,
  tarmika: tarmikaAmbles,
  tivlyagency: tivlyagencyAmbles,
  usgins: usginsAmbles,
};
